import classNames from "classnames/bind";
import UIIcon, { BACKGROUNDABLE_ICONS, NON_BACKGROUNDABLE_ICONS } from "common/blocks/UIIcon";

import styles from "./FormState.module.scss";

const cx = classNames.bind(styles);

export interface FormStateProps {
    icon: keyof typeof BACKGROUNDABLE_ICONS | keyof typeof NON_BACKGROUNDABLE_ICONS;
    title: string;
    text?: string;
    className?: string;
    isRedirect?: boolean;
    redirectText?: string;
    onRedirectClick?: () => void;
}

const FormState = ({
    icon,
    title,
    text,
    className,
    isRedirect,
    redirectText,
    onRedirectClick,
}: FormStateProps) => (
    <div className={cx("info", className)}>
        <UIIcon icon={icon} className={cx("icon")} />
        <div className={cx("content")}>
            <p className={cx("title")}>{title}</p>
            {text && <p className={cx("text")}>{text}</p>}
            {isRedirect && (
                <button className={cx("redirect")} onClick={onRedirectClick}>
                    {redirectText}
                </button>
            )}
        </div>
    </div>
);

export default FormState;
